import React from 'react';
import { ListGroup, ListGroupItem, Button, Badge } from 'reactstrap';

/**
 * Sidebar showing all saved tactics.
 *
 * Props:
 *   tactics       Tactic[]
 *   activeTactic  Tactic | null
 *   onSelect      fn(tactic)
 *   onNew         fn()
 *   onShare       fn(tactic)
 *   onDelete      fn(tactic)
 */
export default function TacticList({ tactics, activeTactic, onSelect, onNew, onShare, onDelete }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', height: '100%' }}>
            <Button color="success" size="sm" onClick={onNew} block>
                + Nueva táctica
            </Button>

            {tactics.length === 0 && (
                <p style={{ fontSize: '0.8rem', color: '#666', marginTop: '0.5rem' }}>
                    No hay tácticas guardadas.
                </p>
            )}

            <ListGroup flush style={{ overflowY: 'auto', flex: 1 }}>
                {tactics.map(t => {
                    const isActive = activeTactic && activeTactic.id === t.id;
                    return (
                        <ListGroupItem
                            key={t.id}
                            active={isActive}
                            action
                            style={{ cursor: 'pointer', padding: '0.45rem 0.6rem' }}
                        >
                            <div
                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                            >
                                <span
                                    onClick={() => onSelect(t)}
                                    style={{ flex: 1, fontWeight: isActive ? 600 : 400, fontSize: '0.875rem' }}
                                >
                                    {t.name || '(sin nombre)'}
                                    {' '}
                                    <Badge
                                        color={t.type === 'offense' ? 'danger' : 'info'}
                                        pill
                                        style={{ fontSize: '0.65rem' }}
                                    >
                                        {t.type === 'offense' ? 'Ataque' : 'Defensa'}
                                    </Badge>
                                </span>
                                <Button
                                    color="secondary"
                                    size="sm"
                                    outline
                                    onClick={(e) => { e.stopPropagation(); onShare(t); }}
                                    style={{ padding: '0 6px', fontSize: '0.75rem', marginLeft: '4px' }}
                                    title="Copiar enlace"
                                >
                                    🔗
                                </Button>
                                <Button
                                    color="danger"
                                    size="sm"
                                    outline
                                    onClick={(e) => { e.stopPropagation(); onDelete(t); }}
                                    style={{ padding: '0 6px', fontSize: '0.75rem', marginLeft: '4px' }}
                                >
                                    x
                                </Button>
                            </div>
                            <div style={{ fontSize: '0.7rem', color: isActive ? '#eee' : '#888' }}>
                                {t.duration}s
                            </div>
                        </ListGroupItem>
                    );
                })}
            </ListGroup>
        </div>
    );
}
